import { Box, Heading, Text, VStack } from "@chakra-ui/react";

const Hero = () => {
  return (
    <Box
      as="header"
      id="hero-top"
      bg="white"
      pt={{ base: 12, md: 20 }}
      pb={{ base: 16, md: 24 }}
      px={{ base: 6, md: 8 }}
    >
      <VStack spacing={6} maxW="4xl" mx="auto" textAlign="center">
        <Heading
          as="h1"
          fontSize={{ base: "2xl", sm: "3xl", md: "4xl", lg: "5xl" }}
          fontWeight={600}
          lineHeight={1.2}
          color="preview.neutral"
          px={{ base: 1, md: 4 }}
        >
          Community Learning Ecosystem{" "}
          <Text as="span" color="preview.primary" fontWeight={700}>
            (CLE)
          </Text>
        </Heading>
        <Text
          as="p"
          fontSize={{ base: "md", md: "lg" }}
          color="cle.charcoal"
          maxW="2xl"
          lineHeight={1.7}
        >
          CLE refers to a dynamic and relational system composed of diverse
          actors, spaces, practices, and structures that interact within a
          community context to enable learning processes.
        </Text>
      </VStack>
    </Box>
  );
};

export default Hero;
